import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Building2, Shield, Users, FileText } from 'lucide-react';

const GovernmentServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Government & Public Sector Solutions | AuVSys</title>
        <meta name="description" content="Digital government solutions with citizen services, cybersecurity, and public sector modernization." />
      </Helmet>

      <div className="government-services">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Government & Public Sector</h1>
              <p>Modernize public services with digital government solutions, enhanced cybersecurity, and citizen-centric service delivery platforms.</p>
            </div>
          </div>
        </section>

        <section className="services-grid">
          <div className="container">
            <div className="grid">
              <div className="service-card">
                <Building2 className="service-icon" />
                <h3>Digital Government</h3>
                <p>Comprehensive digital transformation of government services and operations.</p>
              </div>
              <div className="service-card">
                <Shield className="service-icon" />
                <h3>Public Sector Security</h3>
                <p>Advanced cybersecurity solutions tailored for government and public institutions.</p>
              </div>
              <div className="service-card">
                <Users className="service-icon" />
                <h3>Citizen Services</h3>
                <p>User-friendly digital platforms for citizen engagement and service delivery.</p>
              </div>
              <div className="service-card">
                <FileText className="service-icon" />
                <h3>Compliance & Governance</h3>
                <p>Regulatory compliance solutions and governance frameworks for public sector.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GovernmentServices;